import React from 'react';
import PropTypes from 'prop-types';
import Browser from '@wetransfer/concorde-browser';

const ImagePreview = ({ src, alt, onClick }) => {
  if (Browser.isMobile) {
    return <img src={src} alt={alt} onClick={onClick} />;
  }

  return (
    <div className="preview__item">
      <div className="preview__item--image">
        <img src={src} alt={alt} onClick={onClick} />
      </div>
    </div>
  );
};

ImagePreview.propTypes = {
  alt: PropTypes.string,
  onClick: PropTypes.func,
  src: PropTypes.string,
};

export default ImagePreview;
